// src/Demos/AnnuityDemo.js
import CoordinatePlane from "../MathTools/CoordinatePlane";

export default function AnnuityDemo({
  monthlyDeposit = 200,
  monthlyRate = 0.01,
  months = 12,
  width = 400,
  height = 300
}) {

  const lines = [];
  let maxTotal = 0;
  for (let m = 1; m <= months; m++) {
    const total = monthlyDeposit * ((Math.pow(1 + monthlyRate, m) - 1) / monthlyRate);
    if (total > maxTotal) maxTotal = total;
  
    lines.push({
      start: [m, total],
      end: [m, total],
      color: "blue",
      // Add the money value to the label:
      label: `Month ${m}: $${total.toFixed(2)}`
    });
  }

  // We'll set x-range from 0..months+1, and y-range from 0..some margin above maxTotal
  const xRange = [0, months + 1.5];
  const yRange = [0, Math.ceil(maxTotal / 1000) * 1000]; // round up to nearest 1000

  return (
    <div style={{ margin: "1em 0" }}>
      <h5>Annuity Growth Demo</h5>
      <p style={{ fontSize: "1.1em" }}>
        Each dot shows the total amount after each monthly deposit. 
        (Deposit = ${monthlyDeposit}, rate = {(monthlyRate*100).toFixed(1)}% per month)
      </p>
      <CoordinatePlane
        width={width}
        height={height}
        showAxes={true}
        disablePlot={true}
        lines={lines}
        xDomain={xRange}
        yDomain={yRange}
        axisMode="border"
        xTickValues={Array.from({ length: 14 }, (_, i) => i)}  // [0..13]
        style={{ margin: "0 auto", display: "block" }}
      />
      <p style={{ fontSize: "0.8em", fontStyle: "italic", marginTop: 6 }}>
        Formula: Total(n) = D × [((1 + r)^n − 1) / r]
      </p>
    </div>
  );
}
